module.exports = __webpack_public_path__ + "static/media/vector.5dada95d.svg";